import { render, staticRenderFns } from "./DialogTeacherInfo.vue?vue&type=template&id=450fde1c&scoped=true&"
import script from "./DialogTeacherInfo.vue?vue&type=script&lang=js&"
export * from "./DialogTeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./DialogTeacherInfo.vue?vue&type=style&index=0&id=450fde1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450fde1c",
  null
  
)

export default component.exports